import styled from '@emotion/styled';

export default styled.section`
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0 0 0 1px #00000019, 0 2px #00000003;
  border-radius: 4px;
`;
